import {useState, useContext} from 'react';
import {useNavigate} from 'react-router-dom';
//import axios from 'api';
import api from '../services/api';

import {UserContext} from './UserContext';
export default function useAuth() {
    let navigate = useNavigate();
    const {setUser} = useContext(UserContext);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const msg_erro = {
        messages: "⚠ Erro de conexão, verifique a conexão com a internet ou tente novamente mais tarde"
    }

    const cath_network = (err) => {
        //console.error(err)
        setLoading(false)
        if (err.response) {
            return setError(err.response.data)
        }
        if (err.Error === "Network Error") {
            setError(msg_erro)
        }
        return setError(msg_erro)
    }

    //set user
    async function setUserContext(url) {
        // setLoading(true)
        return await api.get('/user').then(res => {
            setUser(res.data.currentUser);
            // setLoading(false)
            navigate(url);
        }).catch(cath_network)
    }

    async function getDadosCadastrados(data) {
        return api.get(`estados/municipios`, {})
    }

    //register user
    async function registerUser(data) {
        //-dj//console.log(data);
        setError(null)
        setLoading(true)
        let {
            /* ---  para login --- */
            username, password,
            /* --- informações pessoais --- */
            nome, idade, genero, cpf,
            nascimento, deficiente, qual_deficiencia,
            /* --- informações de contato --- */
            email, whatsapp,
            /* --- nformações do endereço --- */
            estado, municipio, bairro, cep,
            /* --- SOBRE A Atuação --- */
            atuacao, atuacao_escola,
            /* --- SOBRE A Escola --- */
            escola, escolaridade, eprofessor
        } = data; //cpf qual_deficiencia


        // tratando dados out
        if (data.escolaridade==='out'){
           escolaridade = data.escolaridade_out
        }

        if (data.escola==='out' || (data.escola==='' && data.escola_out!=="")){
           escola = data.escola_out
        }

        if (data.estado==='out'){
           estado = data.estado_out
        }

        // se municipio é outro
        if (data.municipio === 'out' || data.estado === 'out' || data.estado !== "Maranhão"){
            // e municipio_out é outro ou vazio
            if (data.municipio_out==='out' || data.municipio_out===''){
                municipio = data.municipio_out_out;
            //se municipio_out não é out e nem vazio:
            } else {
                municipio = data.municipio_out;
            }
        }
        //console.log(">>>a",data,"<<<",{estado,municipio,})
        if (data.atuacao==="out"){
          atuacao = data.atuacao_out;
        }
        return api.post(`auth/register`, {
            /* ---  para login --- */
            username, password,
            /* --- informações pessoais --- */
            nome, idade, genero, cpf, nascimento,
            deficiente, qual_deficiencia,
            /* --- informações de contato --- */
            email, whatsapp,
            /* --- nformações do endereço --- */
            estado, municipio, bairro, cep,
            /* --- SOBRE A Atuação --- */
            atuacao, atuacao_escola,
            /* --- SOBRE A Escola --- */
            escola, escolaridade, eprofessor
        }).then(async () => {
            await navigate("/cadastrar/Okay");
            setLoading(false)
        }).catch(cath_network)

        // (err) => {
        //     setLoading(false)
        //     return !!err.response
        //         ? setError(err.response.data)
        //         : (err.Error === "Network Error"
        //             && setError(msg_erro)
        //         )
        // })
    };
    //login user
    async function loginUser(data) {
        const {email, username, password} = data;

        setError(null)
        setLoading(true)

        if (username === 'admin' || email === "admin") {
            return setError({messages: "⚠ Boa tentativa!"})
        }
        if (email === '' || password === "") {
            return setError({messages: "email ou senha estão vazios"})
        }

        return api.post('auth/login', {email, username, password}).then(async (req) => {
            // salvando token no diretorio local
            //localStorage.setItem('@InovOnline:token', req.data.token);
            await setUserContext(data.url || '/planetas/');
            setLoading(false)
        }).catch(cath_network)
    };
    // trocar a senha
    async function chargerPassword(data) {
        const {email, cpf, nascimento, password} = data;

        setError(null)
        setLoading(true)

        return api.post('/auth/charger_password', {email, cpf, nascimento, password}
        ).then(async (req) => {
            await req
            setLoading(false)
            return 'sucess'
            // navigate("/EsqueceuSenha/RedefEnviada");
        }).catch(cath_network)
    };
    // sair
    async function logoutUser() {
        setError(null)
        setLoading(true)
        return await api.get('/auth/logout').then(async res => {
            await setUser(null);
            setLoading(false);
            navigate("/Inicio");
            return res;
        }).catch(cath_network)
    }
    return {
      registerUser, loginUser, logoutUser, chargerPassword,
      getDadosCadastrados,
      error, loading,
    }
}
//
// function  isNetworkError ( err )  {
//   return  ! ! err . isAxiosError  &&  ! err . resposta ;
// }
